import HamHeader from '../../../components/Fireboard/components/Header/HamburgerHeader';
import styles from './about.module.scss';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { formatPhoneNumber } from '@utility/fireboardUtil';
import pkg from '../../../../package.json';
import cn from 'classnames';
import { ReactComponent as Phone } from '@assets/images/contactIconFb.svg';
import { goToView } from '../../../utility/fireboardUtil';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const TabInfo = ({ currentView }) => {
  const navigate = useNavigate();
  const storeInfo = JSON.parse(window.sessionStorage.getItem('auth'));
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));

  const getEnv = () => {
    const envMode = process.env.REACT_APP_MODE;
    switch (envMode) {
      case 'DEV':
        return 'Development';
      case 'UAT':
        return 'UAT';
      case 'RND':
        return 'RND';
      default:
        return 'Production';
    }
  };

  const SystemInfo = () => {
    const info = [
      { label: FLABEL().ABOUT_STORE_NAME, value: storeInfo?.name || 'NA' },
      { label: FLABEL().ABOUT_DEVICE_NAME, value: deviceInfo?.deviceName || 'NA' },
      {
        label: FLABEL().ABOUT_DEVICE_GROUP_NAME,
        value: deviceInfo?.deviceGroup?.name || 'NA',
      },
      { label: FLABEL().ABOUT_WEB_VERSION, value: pkg.version || 'NA' },
      { label: FLABEL().ABOUT_ENVIRONMENT, value: getEnv() || 'NA' },
    ];

    return (
      <>
        <div className={styles.tabButtons}>
          <span className="pb-3">{FLABEL().ABOUT_SYSTEM_INFO}</span>
        </div>
        <div className={`${styles.tabContainer} m-0 p-0`}>
          {info.map(item => (
            <div className={styles.infoRow} key={item.label}>
              <span className={styles.label}>{item.label}</span>
              <span>{item.value}</span>
            </div>
          ))}
        </div>
      </>
    );
  };

  const ContactInfo = () => {
    return (
      <>
        <div className={cn(styles.tabButtons, 'mt-4')}>
          <span className="pb-3">{FLABEL().ABOUT_SUPPORT_CONTACT}</span>
        </div>
        <div className={styles.contactGrid}>
          <div className={styles.contactCard}>
            <div className={styles.contactIcon}>
              <Phone />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.contactTitle}>
                {FLABEL().ABOUT_ONEDINE}
              </div>
              <div className={styles.contactNumber}>
                {formatPhoneNumber(storeInfo?.supportPhoneNumber)}
              </div>
            </div>
          </div>

          <div className={styles.contactCard}>
            <div className={styles.contactIcon}>
              <Phone />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.contactTitle}>{FLABEL().ABOUT_DOORDASH_DRIVE_DELIVERY}</div>
              <div className={styles.contactNumber}>(855) 973-1040</div>
            </div>
          </div>

          <div className={styles.contactCard}>
            <div className={styles.contactIcon}>
              <Phone />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.contactTitle}>{FLABEL().ABOUT_DOORDASH_MARKETPLACE}</div>
              <div className={styles.contactNumber}>(855) 973-1040</div>
            </div>
          </div>

          <div className={styles.contactCard}>
            <div className={styles.contactIcon}>
              <Phone />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.contactTitle}>{FLABEL().ABOUT_GRUBHUB_MARKETPLACE}</div>
              <div className={styles.contactNumber}>(877) 585-7878</div>
            </div>
          </div>

          <div className={styles.contactCard}>
            <div className={styles.contactIcon}>
              <Phone />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.contactTitle}>{FLABEL().ABOUT_UBEREATS_MARKETPLACE}</div>
              <div className={styles.contactNumber}>(833) 275-3287</div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <HamHeader
        label={FLABEL().HEADER_ABOUT}
        onClickback={() => goToView(currentView, navigate)}
      />
      <div className={cn(styles.tabContainer, 'mt-3')}>
        <div className={styles.tabContent}>
          <SystemInfo />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ oauth }) => ({
  currentView: oauth.currentView,
});

export default connect(mapStateToProps)(TabInfo);
